import { createReducer, on } from '@ngrx/store';
import { 
  PRODUCT_FIND_SUCCESS,
  PRODUCT_FAILED,
  PRODUCT_UPDATE_LOADING,
  PRODUCT_UPDATE_ID,
  SUGGESTION_ITEMS_FIND_SUCCESS,
  SUGGESTION_ITEMS_FIND_RESET,
 } from '../actions'
import {  MenuItem  } from '@core/models';

export interface ProductState {
  loading: boolean;
  productList: MenuItem[] | null;
  suggestionItems: MenuItem[] | null;
  error: string | null;
  idArticulo: string | null
}

const initialState: ProductState = {
  loading: false,
  productList: null,
  suggestionItems: null,
  error: null,
  idArticulo: null
}

export const productReducer = createReducer(
  initialState,
  on(PRODUCT_FIND_SUCCESS, (state, { productList }) => ({ ...state, productList })),
  on(PRODUCT_UPDATE_ID, (state, { idArticulo }) => ({ ...state, idArticulo })),
  on(PRODUCT_FAILED, (state, { error }) => ({ ...state, error })),
  on(PRODUCT_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(SUGGESTION_ITEMS_FIND_SUCCESS, (state, { suggestionItems }): ProductState => ({ ...state, suggestionItems })),
  on(SUGGESTION_ITEMS_FIND_RESET, (state, ): ProductState => ({ ...state, suggestionItems: initialState.suggestionItems })),
);
